import { Trans } from '../i18n/Trans';

export interface JobView {
  id: string;
  status: 'running' | 'done' | 'error';
  stage: string;
  done: number;
  total: number;
  lines: number;
  priced: number;
  percent: number;
  elapsedMs: number;
  limitMs: number;
  pollMs: number;
  fileName: string;
  msg?: string;
}

const sec = (ms: number) => `${Math.floor(ms / 1000)}s`;

/**
 * 估价进度卡。一份 BOM 要 12~30s，光让按钮转圈是不够的：
 * 这里给的是**真数字** —— 阶段名、已完成/总子任务数、已报价行数、已用时与硬上限。
 * 百分比是按已完成子任务数估的，所以下面明写了依据，不假装它是剩余时间。
 */
export function QuoteProgress({ job }: { job: JobView }) {
  const pct = Math.max(0, Math.min(100, job.percent));
  return (
    <section className="progress-card" role="status" aria-live="polite">
      <div className="progress-head">
        <div>
          <div className="progress-title">{Trans.t('job.title')}</div>
          <div className="progress-file">{job.fileName}</div>
        </div>
        <div className="progress-pct">{pct}<small>%</small></div>
      </div>

      <div className="progress-bar" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>

      <div className="progress-meta">
        <span className="progress-stage">{Trans.t(`job.stage.${job.stage}`)}</span>
        {job.total > 0 && (
          <span>{job.done}/{job.total} {Trans.t('job.sub')}</span>
        )}
        <span>{Trans.t('job.priced')} {job.priced}/{job.lines} {Trans.t('job.lines')}</span>
        <span className="progress-time">
          {Trans.t('job.elapsed')} {sec(job.elapsedMs)} · {Trans.t('job.limit')} {sec(job.limitMs)}
        </span>
      </div>

      <p className="hint progress-basis">{Trans.t('job.basis')}</p>
    </section>
  );
}
